import React from 'react';
import { CSidebarHeader } from '@coreui/react';
import { styled } from "@mui/system";
import Juliaca from "../../assets/img/Juliaca.png";
import Aniversario from "../../assets/img/aniversario.png";

const CenterContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; /* centra verticalmente */
  text-align: center;
  padding: 20px;
`;

const LogoContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap; /* permite que se adapten en pantallas pequeñas */
`;

const LogoImage = styled("img")`
  height: 180px;
  width: auto;
  max-width: 90%;
`;

const WelcomeText = styled("div")`
  font-size: 2rem; /* tamaño destacado */
  font-weight: 600;
  color: #2c3e50;
`;

const AdminPageContent = () => {
  return (
    <CSidebarHeader className="border-bottom" style={{ height: '100%' }}>
      <CenterContainer>
        <LogoContainer>
          <LogoImage src={Juliaca} alt="San Román" />
          <LogoImage src={Aniversario} alt="Para Ti" />
        </LogoContainer>
        <WelcomeText>
          Bienvenido al panel de administración
        </WelcomeText>
      </CenterContainer>
    </CSidebarHeader>
  );
};

export default AdminPageContent;
